// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__ggiNY","note":"pending-approval-badge_note__mXh-5","icon":"pending-approval-badge_icon__K4Jl0"};